(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recipe-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recipe-detail]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const printButton = section.querySelector('[data-print-recipe]');
    if (printButton) printButton.addEventListener('click', () => window.print());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-index"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recipe-index]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const search = section.querySelector('[data-recipe-search]');
    const filters = Array.from(section.querySelectorAll('[data-recipe-filter]'));
    const cards = Array.from(section.querySelectorAll('[data-recipe-card]'));
    const empty = section.querySelector('[data-recipe-empty]');
    let activeCategory = 'all';

    if (!search) return;

    const updateRecipes = () => {
      const term = search.value.trim().toLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesCategory = activeCategory === 'all' || card.dataset.category === activeCategory;
        const searchableText = `${card.dataset.title} ${card.dataset.description}`;
        const matchesSearch = term === '' || searchableText.includes(term);
        const isVisible = matchesCategory && matchesSearch;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      empty.hidden = visibleCount !== 0;
    };

    search.addEventListener('input', updateRecipes);

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.recipeFilter;
        filters.forEach((button) => {
          const isActive = button === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        updateRecipes();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
